import { ReactNode } from 'react';

export const Template = ({ children }: { children: ReactNode }) => {
  return <div className='mb-16 grid grid-cols-3 gap-4'>{children}</div>;
};
